
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 14.5","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.168 9.256c-.592-.56-.888-1.27-.888-2.128 0-.859.299-1.573.896-2.144.597-.576 1.355-.864 2.272-.864.656 0 1.248.147 1.776.44v1.28c-.56-.384-1.144-.576-1.752-.576-.57 0-1.035.179-1.392.536-.352.352-.528.792-.528 1.32 0 .523.173.963.52 1.32.352.357.816.536 1.392.536.272 0 .51-.043.712-.128v-.872H7.168V6.92h2.24v2.688c-.576.32-1.232.48-1.968.48-.923 0-1.68-.277-2.272-.832z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M7.071 0A7.07 7.07 0 000 7.071 7.07 7.07 0 107.071 0zm4.125 11.197a5.81 5.81 0 01-4.125 1.708 5.81 5.81 0 01-4.125-1.708 5.81 5.81 0 01-1.709-4.125 5.81 5.81 0 011.709-4.125 5.81 5.81 0 014.125-1.709 5.81 5.81 0 014.125 1.709 5.81 5.81 0 011.709 4.125 5.81 5.81 0 01-1.709 4.125z","fill":"currentColor"}})])
          )
        }
      }
    